import { ChangeDetectorRef, Component, OnInit, Renderer2 } from '@angular/core';
import { Router } from "@angular/router";
import { CommonService } from "@app/shared/common/common.service"
import { LayoutService } from "@app/shared/layout/layout.service";
import { environment } from '@env/environment';
import { I18nService } from '@app/shared/i18n';
import { ApplicationMenuService } from './application-menu/application-menu.service';
import { Subscription } from 'rxjs';
import { EmitService } from '@app/ts/services/emit.service';

declare var $: any;

@Component({
  selector: 'sa-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public profilePhoto = "";
  toggletitle: string;
  logo: string;
  showCart: boolean = true;
  showNotifications: boolean;
  isDarkMode = false;
  imgAlt="";
  instanceId;
  shortCuts;
	langChangeSubscription: Subscription;
  lanId;
  toggleClass: boolean = JSON.parse(localStorage.getEncryptedItem('notesVisible'));
  showReminder;
  instance = '';
  valuesIn = [];
  newBuildOptions:{};
  buildAlert: string;
  test_env: boolean = false;
  constructor(private router: Router, private userService: CommonService,private layoutService: LayoutService,private i18nService: I18nService,private _applicationService:ApplicationMenuService,private emitService:EmitService,private commonService:CommonService, private cd: ChangeDetectorRef,private renderer: Renderer2 ) {
    
    setTimeout(() => {
      if( environment.color != "" ){
        this.renderer.addClass(document.body, environment.color);
        this.test_env = true;
      }
      else{
        this.test_env = false;
      }
    });
        
    this.toggletitle = this.i18nService.getTranslation("common_all_stickyNotes_hide");
    if(localStorage.getEncryptedItem('logo')){
        let logo = JSON.parse(localStorage.getEncryptedItem('logo')).normalLogo;
        this.logo = environment.NETGATE_URL+logo;
    }
    if(localStorage.getEncryptedItem('companyName')){
      this.imgAlt=localStorage.getEncryptedItem('companyName')+ ' logo'
    }
    if(localStorage.getEncryptedItem('instanceId')){
      this.instanceId =  localStorage.getEncryptedItem('instanceId')
    }
    if(localStorage.getEncryptedItem('instanceId')){
      this.instance =  localStorage.getEncryptedItem('instance')
    }
    if(this.toggleClass){
      $('.notes.notes-box').hide();
    }
    else{
      $('.notes.notes-box').removeClass('hideshow');
      $('.notes.notes-box').show();
    }
    this.toggleClass = !this.toggleClass;
    this.initNewBuildPopup();
    setTimeout(()=>{
      // let rights = this.commonService.getCookie(environment.userRights) ? 
      //               JSON.parse(this.commonService.decrypt(decodeURIComponent(this.commonService.getCookie(environment.userRights)))).userRights :
      //               this.commonService.logout();
      let rights = localStorage.getEncryptedItem('userRights');
      let rightsArray = rights.split(',')  
      this.showCart=rightsArray.includes('ngtMPur');
      this.showNotifications=rightsArray.includes('ngtMInv');
      this.showReminder = rightsArray.includes('ngtMCon');
    })
    this.layoutService.subscribedarkThemeActivated(darkTheme=>{
      this.isDarkMode = !!darkTheme;
      if(darkTheme){
        if(localStorage.getEncryptedItem('logo')){
          let logo = JSON.parse(localStorage.getEncryptedItem('logo')).whiteTheme!=''?JSON.parse(localStorage.getEncryptedItem('logo')).whiteTheme:JSON.parse(localStorage.getEncryptedItem('logo')).normalLogo;
          this.logo = environment.NETGATE_URL+logo;
          
         }
      }else{
        if(localStorage.getEncryptedItem('logo')){
          let logo = JSON.parse(localStorage.getEncryptedItem('logo')).normalLogo;
          this.logo = environment.NETGATE_URL+logo;
         }
      }
    });
    $("body").off('click', '.addLinkText').on('click', '.addLinkText',  ()=> {
      this.addShortCuts();
    });
    $("body").off('mouseenter', '.sticky-shortCuts').on('mouseenter', '.sticky-shortCuts',  ()=> {
      // this.addShortCuts();
      $(".linkIcon").css("display","none")
    });
    $("body").off('mouseleave', '.sticky-shortCuts').on('mouseleave', '.sticky-shortCuts',  ()=> {
      // this.addShortCuts();
      $(".linkIcon").css("display","block")
      $(".renameBookmarkLink").attr("hidden",true);
      $(".bookmarkLink").attr("hidden",false);
      $(".popover").remove();
    });
    $("body").off('click', '.shortCutBox').on('click', '.shortCutBox',  (e)=> {
      this.navigateTo(e.currentTarget.id)
    });
    $("body").off('click', '.renameShortcut').on('click', '.renameShortcut',  (event)=> {
      event.stopPropagation();
      let id = $(event.currentTarget).attr("data-id");
      setTimeout(() => {
        $(".bookmarkLink_"+id).attr("hidden",true);
        $("#renameBookmarkLink_"+id).attr("hidden",false);
        $("#renameBookmarkLink_"+id).focus();
      },1000);
      $("body").off('focusout', '#renameBookmarkLink_'+id).on('focusout', '#renameBookmarkLink_'+id,  (e)=> {
        let renameValue = $(e.target).val();
        let id = $(e.currentTarget).attr("data-id");
        this.valuesIn.push(id);
        if(this.valuesIn.length == 1)
        this.renameShortcut(id,renameValue)
        $("#renameBookmarkLink_"+id).attr("hidden",true);
        $(".bookmarkLink_"+id).attr("hidden",false);
      });
      $("body").off('click', '#renameBookmarkLink_'+id).on('click', '#renameBookmarkLink_'+id,  (e)=> {
        e.stopPropagation();
      });
      $('body').off('keyup', '#renameBookmarkLink_'+id).on('keyup', '#renameBookmarkLink_'+id, (ev) => {
        if (ev.keyCode === 13) {
          let id = $(ev.currentTarget).attr("data-id");
          $("#renameBookmarkLink_"+id).focusout();
        }
      });
    });
    
    $('body').off('mouseenter', '.shortCutBox').on('mouseenter', '.shortCutBox', function() {
      $(".popover").remove();
      let label = $(this).closest(".shortCutBox").attr("data-label");
      let url = $(this).closest(".shortCutBox").attr("data-url");
			let dataContent = '<div class="row companyTooltip">';
      dataContent = dataContent + '<div class="col-sm-12 col-lg-12 text-center">'+label+'</div><br>';
      dataContent = dataContent + '<div class="col-sm-12 col-lg-12 text-center">'+url+'</div><br>';
			dataContent = dataContent + '</div>';
			$(this).attr("data-content",dataContent);
			// $(this).popover('show');
      let closest_fileType = $(this);
			$(this).closest('tr').unbind('mouseenter mouseleave')
			$(closest_fileType).append(dataContent);
		});
    $('body').off('mouseleave', '.shortCutBox').on('mouseleave', '.shortCutBox', (event) => {
      $(event.currentTarget).parent().find(".companyTooltip").remove();
    });
		// });
    this.langChangeSubscription = this.i18nService.langChangeEvent.subscribe(langObj => 
    setTimeout(() => {
      this.onLangChangeShortCut(langObj); 
    }, 500));
    
    this.emitService.newDistEvent.subscribe(data=>{
      if(data){
        this.buildAlert = this.i18nService.getTranslation('build_alert');
        this.initNewBuildPopup();
        $('#newBuild').dialog("open")
      }
      
    })
  }

  ngOnInit() {    
    // $('.shortCutBoxPopupOver').popover({
		// 	placement: 'bottom',
		// 	html: true,
		// 	trigger: 'hover',
		// 	container:'body',
		// 	width: 'auto',
		// 	content: function() {
		// 		return $(this).data('popover');
		//   },			  
    // })
    let cookieExist = this.commonService.getCookie(environment.loginCookie) ? 
                      this.commonService.decrypt(decodeURIComponent(this.commonService.getCookie(environment.loginCookie))) :
                      this.commonService.logout();
    if (cookieExist) {
      cookieExist = JSON.parse(cookieExist);
      let style = JSON.parse(cookieExist['style']);
      console.log(style);
      setTimeout(() => {
          this.layoutService.processBody(style)
          // Ensure toggle state matches the applied skin on first load.
          this.isDarkMode = (this.layoutService.store?.smartSkin || '').indexOf('darktheme') >= 0;
      }, 200)
  }    
  }

  setThemeMode(isDark: boolean) {
    const nextSkin = isDark ? 'smart-style-5 darktheme' : 'smart-style-2';
    const currentSkin = this.layoutService.store?.smartSkin || localStorage.getItem('sm-skin') || '';

    if (currentSkin === nextSkin) {
      this.isDarkMode = isDark;
      return;
    }

    this.isDarkMode = isDark;
    this.layoutService.processBody({
      ...this.layoutService.store,
      smartSkin: nextSkin
    });

    // Persist to cookie as well; ngOnInit reapplies `style` from login cookie on refresh.
    try {
      const cookieRaw = this.commonService.getCookie(environment.loginCookie);
      if (cookieRaw) {
        const decrypted = this.commonService.decrypt(decodeURIComponent(cookieRaw));
        const cookieObj = JSON.parse(decrypted);
        const styleObj = cookieObj?.style ? JSON.parse(cookieObj.style) : {};
        styleObj.smartSkin = nextSkin;
        cookieObj.style = JSON.stringify(styleObj);
        this.commonService.setCookie(
          environment.loginCookie,
          this.commonService.encrypt(JSON.stringify(cookieObj)),
          environment.SESSION_EXPIRY,
          environment.SUB_DOMAIN,
          '/'
        );
      }
    } catch (e) {
      // Best-effort: theme still applies via localStorage/body classes.
    }
  }

  ngAfterViewChecked() {
    // Added this code to resolve ExpressionChangedAfterItHasBeenCheckedError.
    this.cd.detectChanges();
    this.cd.detach();
    this.layoutService.subscribeProfilePhoto(profilePhoto=>{
      if(typeof(profilePhoto) !== "object"){
        this.profilePhoto = profilePhoto
      }
    });
  }


  searchMobileActive = false;

  toggleSearchMobile() {
    this.searchMobileActive = !this.searchMobileActive;

    $('body').toggleClass('search-mobile', this.searchMobileActive);
  }

  showstickynotes(){
    $('notes-container').addClass('active');
    $('notes-container .creator').css('display','block');
  }

  showhidestickynotes(){
    this.toggleClass = !this.toggleClass;
    localStorage.setEncryptedItem('notesVisible',JSON.stringify(!this.toggleClass));
    if(this.toggleClass){
      $('.notes.notes-box').hide();
    }
    else{
      $('.notes.notes-box').removeClass('hideshow');
      $('.notes.notes-box').show();
    }

  }

  onSubmit() {
    this.router.navigate(['/miscellaneous/search']);

  }
  addShortCuts(){
    var label = '';
    var ul = $("ol.breadcrumb li");
    for (let i = 0; i < ul.length; i++) {
      if(i!=ul.length-1)
        label = label + ul.eq(i).attr("id") + '|';
      else
        label = label + ul.eq(i).attr("id");
    }
    var formData = new FormData();
    formData.append("companyId", localStorage.getEncryptedItem('companyId'));
    formData.append("instanceId", localStorage.getEncryptedItem('instanceId'));
    formData.append("companyUserId", localStorage.getEncryptedItem('companyUserId'));
    formData.append("label", label);
    let appDetail = JSON.parse(localStorage.getItem('appDetail'));
    var tempNavObj = this.layoutService.getNavId();
    // var pathname = window.location.href.split('#')[1]
    var pathname = window.location.pathname
    var tempNavId = appDetail.path == pathname ? appDetail.id :  tempNavObj.navId;
    if(pathname == tempNavObj.navPath)
    {
      formData.append("navId", tempNavId);

    }
    else{
      formData.append("path", pathname);
    }
    let objectCount = this.userService.createObject(formData)
    let tokenCount = this.userService.createToken(objectCount)
    let encryptedTokenCount = this.userService.encrypt(tokenCount)
    let encrDataCount = new FormData()
    encrDataCount.append("encrToken", encryptedTokenCount);
    this._applicationService.addShortCuts(encrDataCount).subscribe((data:any) => {
      // this.getShortCuts();
    });
    }
    getShortCuts(){
      var formData = new FormData();
      formData.append("companyId", localStorage.getEncryptedItem('companyId'));
      formData.append("instanceId", localStorage.getEncryptedItem('instanceId'));
      formData.append("companyUserId", localStorage.getEncryptedItem('companyUserId'));
      formData.append("language", this.userService.getCurrentLanguageCode());
      let object = this.userService.createObject(formData)
      let token = this.userService.createToken(object)
      let encryptedToken = this.userService.encrypt(token)
      let encrData = new FormData()
      encrData.append("encrToken", encryptedToken);
      this._applicationService.getShortCuts(encrData).subscribe((data:any) => {
      if(data.STATUS == true){
        this.shortCuts = data.DATA.POSTIT;
        this.shortCuts.forEach(obj => {
          let array = obj.hoverLabel.split('|');
          let hoverLabelTemp = '';
          array.forEach(element => {
            hoverLabelTemp = hoverLabelTemp+this.i18nService.getTranslation(element)+' / '
          });
          obj['hoverLabelTemp'] = hoverLabelTemp.slice(0,-2);
          obj.label = this.i18nService.getTranslation(obj.label.split('|').reverse()[0]);
        });
      }
    });
  }
    navigateTo(module){
      this.router.navigate([module]);
    }
    onLangChangeShortCut(langObj){
      langObj.isHandled = true;
      // this.getShortCuts()

    }
    deleteShortcut(id){
      var formData = new FormData();
      formData.append("deleteId", id);
      let object = this.userService.createObject(formData)
      let token = this.userService.createToken(object)
      let encryptedToken = this.userService.encrypt(token)
      let encrData = new FormData()
      encrData.append("encrToken", encryptedToken);
      this._applicationService.deleteShortCuts(encrData).subscribe((data:any) => {
        if(data.status == true)
        {
          // this.getShortCuts();
        }
    });
    }
    renameShortcut(id,renameValue){
      var formData = new FormData();
      formData.append("updateId", id);
      formData.append("userLabel", renameValue);
      let object = this.userService.createObject(formData)
      let token = this.userService.createToken(object)
      let encryptedToken = this.userService.encrypt(token)
      let encrData = new FormData()
      encrData.append("encrToken", encryptedToken);
      this._applicationService.renameShortcut(encrData).subscribe((data:any) => {
        if(data.status == true)
        {
          // this.getShortCuts();
        }
        setTimeout(() => {
          this.valuesIn = [];
        }, 1000);
    });
    }

    backTo() {
      let instance = localStorage.getEncryptedItem('instance');
      localStorage.clear();
      // instance ?  window.location.href = 'http://'+instance+environment.dashboard_url: this.router.navigate(['/unauthorized']);
      instance ?  window.location.href = 'https://'+instance+environment.dashboard_url: this.router.navigate(['/unauthorized']);
    }
    // initNewBuildPopup() {
    //   $('#newBuild').dialog({
    //     // configuration options for the dialog
    //     title:this.i18nService.getTranslation('newversion_available'),
    //     modal: true,
    //     autoOpen: false,
    //     width: 400,
    //     height: 200,
    //     // other options
    //   });
    // }
    logout() {
      console.log("logout")
      let instance = localStorage.getEncryptedItem('instance');
      localStorage.clear();
      // instance ?  window.location.href = 'http://'+instance+environment.logout_url: this.router.navigate(['/unauthorized']);
      instance ?  window.location.href = 'https://'+instance+environment.logout_url: this.router.navigate(['/unauthorized']);
    }

    initNewBuildPopup() {
      var header = this.i18nService.getTranslation('newversion_available')
      this.newBuildOptions = {
        autoOpen: false,
        modal: true,
        // dialogClass: 'deletegroupmember',
        width: 700,
        height: 300,
        resizable: false,
        closeText: '',
        title: "<div class='widget-header'><h4><i class='fa fa-list-ul'></i> &nbsp;" + header + "</h4></div>",
        close: () => {
          location.reload();
          this.clearCache();
        }
      };
      $("#newBuild").dialog(this.newBuildOptions);
    }

    clearCache() {
      location.reload();
      // this.commonService.clearCookieStorage();
      this.commonService.logout();
    }
    
    errorAlertOk() {
      
    }
}
